import React, { useEffect, useState } from 'react';
import { FaXTwitter } from "react-icons/fa6";

export default function Footer({ Details, Loading }) {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        // Simulate page loading or wait for actual page load
        const handleLoad = () => setIsLoading(false);

        if (document.readyState === 'complete') {
            setIsLoading(false);
        } else {
            window.addEventListener('load', handleLoad);
        }

        return () => window.removeEventListener('load', handleLoad);
    }, []);

    if (Details) return (
        <footer className={`bg-secondary-500 text-white py-8 mt-12 w-full transition-all duration-500 ${Loading ? 'fixed bottom-0' : 'relative'}`}>
            <div className="container mx-auto px-4 flex flex-col md:flex-row justify-between items-center gap-6">
                {/* Owner Info */}
                <div className="text-center md:text-left">
                    <h2 className="text-lg font-semibold">© {new Date().getFullYear()} Technology Lines</h2>
                    <p className="text-sm mt-1">All rights reserved. Designed & developed with.</p>
                </div>

                {/* Social Icons */}
                <div className="flex gap-4 text-xl">
                    <a
                        href="https://www.linkedin.com/in/ziad-ahmed-%F0%9F%87%B5%F0%9F%87%B8-8118a4233/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hover:text-primary-500 transition"
                    >
                        <FaXTwitter />
                    </a>
                </div>
            </div>
        </footer>
    );

    return (
        <footer className={`bg-secondary-500 text-white py-8 mt-12 w-full transition-all duration-500 ${isLoading ? 'fixed bottom-0' : 'relative'}`}>
            <div className="container mx-auto px-4 flex flex-col md:flex-row justify-between items-center gap-6">
                {/* Owner Info */}
                <div className="text-center md:text-left">
                    <h2 className="text-lg font-semibold">© {new Date().getFullYear()} Technology Lines</h2>
                    <p className="text-sm mt-1">All rights reserved. Designed & developed with.</p>
                </div>

                {/* Social Icons */}
                <div className="flex gap-4 text-xl">
                    <a
                        href="https://www.linkedin.com/in/ziad-ahmed-%F0%9F%87%B5%F0%9F%87%B8-8118a4233/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hover:text-primary-500 transition"
                    >
                        <FaXTwitter />
                    </a>
                </div>
            </div>
        </footer>
    );
}
